import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Banner } from '@superops/ui-design-system';

import { getTranslatedText, ERROR_CODES } from '@nile/components';
import { ERROR_CODES_ITEM_MAP } from '@nile/client_management/src/Constants/invoice';

const integrationAppIdNameMap = {
  QUICK_BOOKS_ONLINE: 'Quickbooks',
  XERO: 'Xero'
};

const InvoiceErrors = ({
  paymentErrors = [],
  thirdPartyErrors = [],
  integratedAppId = 'QUICK_BOOKS_ONLINE',
  intl
}) => {
  const errorsArray = [...paymentErrors, ...thirdPartyErrors];

  const errorString = errorsArray.reduce((acc, error) => {
    let items = '';

    if (error.params) {
      const itemsArray =
        error.params[ERROR_CODES_ITEM_MAP[error.errorCode]] ||
        error.params.items ||
        [];
      const itemStrings = itemsArray.map((item) => `${item.name}`);
      items = `(${itemStrings.join(', ')})`;
    }

    return `${acc}${getTranslatedText(
      intl,
      ERROR_CODES[error.errorCode] || error.message || ' '
    )} ${items}\n`;
  }, '');

  return (
    <Banner status="critical">
      <div className="fw flex fcol hfc">
        <div className="fw-bold mb8">
          <FormattedMessage
            id="invoice.integration.error.title"
            values={{
              thirdPartyApp: integrationAppIdNameMap[integratedAppId]
            }}
          />
        </div>
        <div className="fw ws-prewrap">{errorString}</div>
      </div>
    </Banner>
  );
};

export default injectIntl(InvoiceErrors);
